import { render, staticRenderFns } from "./SubscribeEDM.vue?vue&type=template&id=84d1fd84&scoped=true"
import script from "./SubscribeEDM.vue?vue&type=script&lang=js"
export * from "./SubscribeEDM.vue?vue&type=script&lang=js"
import style0 from "./SubscribeEDM.vue?vue&type=style&index=0&id=84d1fd84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d1fd84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84d1fd84')) {
      api.createRecord('84d1fd84', component.options)
    } else {
      api.reload('84d1fd84', component.options)
    }
    module.hot.accept("./SubscribeEDM.vue?vue&type=template&id=84d1fd84&scoped=true", function () {
      api.rerender('84d1fd84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SubscribeEDM.vue"
export default component.exports